import {
    CardFormErrorRequest,
    CardFormInputValue,
    CardInputRequest,
    CardSubmitRequest,
    ErrorResponse,
    GTMEventRequest,
    InputType,
} from '../models/models';

/**
 * @description Provides supported event type names
 *
 * @stable
 */
export enum EventType {
    card_submit = 'card_submit',
    card_submit_response = 'card_submit_response',
    page_loaded = 'page_loaded',
    card_input = 'card_input',
    card_input_disable = 'card_input_disable',
    card_input_enable = 'card_input_enable',
    card_form_valid = 'card_form_valid',
    card_deposit_failed = 'card_deposit_failed',
    card_input_clear = 'card_input_clear',
    card_form_invalid = 'card_form_invalid',
    cashier_bin_check = 'cashier_bin_check',
    cashier_bin_check_response = 'cashier_bin_check_response',
    ngpg_bin_check_response = 'ngpg_bin_check_response',
    card_form_error = 'card_form_error',
    validate_card_holder_name = 'validate_card_holder_name',
    validated_card_holder_name = 'validated_card_holder_name',
    name_on_card_check = 'name_on_card_check',
    name_on_card_check_response = 'name_on_card_check_response',
    card_form_input_value = 'card_form_input_value',
    show_cvv_tooltip = 'show_cvv_tooltip',
    card_preference_name = 'card_preference_name',
    anchor_click = 'anchor_click',
    gtm_event_request = 'gtm_event_request',
    focus_input = 'focus_input',
    clear_events = 'clear_events',
    update_card_input = 'update_card_input',
}

export interface EventData {
    eventName: string;
    payload?:
        | { [key: string]: string }
        | CardSubmitRequest
        | CardInputRequest
        | ErrorResponse
        | CardFormErrorRequest
        | CardFormInputValue
        | GTMEventRequest;
}

//define the type of object that is passed as part of the event below
export type CustomEvents = {
    card_input: CardInputRequest;
    card_submit: CardSubmitRequest;
    card_submit_response: { [key: string]: string } | ErrorResponse;
    page_loaded: undefined;
    card_input_disable: undefined;
    card_input_enable: undefined;
    card_form_valid: undefined;
    card_input_clear: undefined;
    card_form_invalid: undefined;
    cashier_bin_check: { [key: string]: string };
    cashier_bin_check_response: { [key: string]: string };
    ngpg_bin_check_response: { [key: string]: string };
    card_form_error: CardFormErrorRequest;
    validate_card_holder_name: { [key: string]: string };
    validated_card_holder_name: { [key: string]: string };
    name_on_card_check: { [key: string]: string };
    name_on_card_check_response: { [key: string]: string };
    card_form_input_value: CardFormInputValue;
    card_preference_name: string;
    anchor_click: { [key: string]: string };
    gtm_event_request: GTMEventRequest;
    show_cvv_tooltip: undefined;
    focus_input: InputType;
    clear_events: undefined;
    update_card_input: CardInputRequest;
    dummy_event: string;
    dummy_event_2: { [key: string]: unknown };
};
